module.exports = __webpack_public_path__ + "static/media/planning-name.39238970.svg";